import {useAuth} from 'app/modules/auth'
import AdminDashboard from './AdminDashboard'

const DashboardWrapper = () => {
  const {currentUser} = useAuth()
  const pos = currentUser?.position

  const firstRole = currentUser?.roles?.[0] || null

  // if (firstRole === 'Lecturer') return <LecturerDashboard />
  // else if (pos === 'Student') return <StudentDashboard />
  // else if (pos === 'Online Student') return <OnlineStdDashboard />
  // else if (currentUser?.position === 'Parent') return <ParentDashboard />
  // else
  return <AdminDashboard />
}

export {DashboardWrapper}
